import { useState, useEffect } from "react";
import { Grid, Stack, Typography, Box } from "@mui/material";
import httpClient from '../../_util/api';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import StatCard from "../../components/StatCard";

const DashboardOverview = () => {
  const [applications, setApplications] = useState({
    inprocess: 0,
    rejected: 0,
    completed: 0,
    total: 0,
  });

  const [allUsers, setAllUsers] = useState({
    totalApplications: 0,
    totalStudents: 0,
    totalVendors: 0,
    totalReviewer: 0,
    totalApprover: 0,
    totalRecordKeeper: 0,
    totalFinance: 0,
  });
  
  const originalData = [
    { name: "In process", value: applications.inprocess, color: "#2f62a5" },
    { name: "Rejected", value: applications.rejected, color: "#e74c3c" },
    { name: "Completed", value: applications.completed, color: "#27ae60" },
  ];

  const data = originalData.filter(item => item.value > 0);

  const getAllApplciationCount = async () => {
    try {
      const res = await httpClient.get('/count/all');
      if (res.status === 200) {
        setApplications(res.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

   const getAllUserCount = async () => {
    try {
      const res = await httpClient.get('/count/allUsers');
      if (res.status === 200) {
        setAllUsers(res.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getAllApplciationCount();
    getAllUserCount();
  }, []);

  return (
    <Stack spacing={3} sx={{ width: "100%", padding: 3 }}>
      <Typography variant="h6" fontWeight="bold">
        Dashboard Overview
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="Total Applications" count={allUsers.totalApplications} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="Total Students" count={allUsers.totalStudents} color="green" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="Total Vendors" count={allUsers.totalVendors} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="Total Scholarship Reviewer" count={allUsers.totalReviewer} color="green" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="Total Scholarship Approver" count={allUsers.totalApprover} color="green" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="Total Record Keeper" count={allUsers.totalRecordKeeper} color="green" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="Total Finance Admin" count={allUsers.totalFinance} color="green" />
        </Grid>
      </Grid>
      <Box
        sx={{
          bgcolor: "white",
          p: 3,
          mt: 3,
          borderRadius: "12px",
          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <Typography variant="h6" fontWeight="bold" mb={2}>
          Applications Overview
        </Typography>
        {data.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <Typography>No data to display in chart.</Typography>
        )}
      </Box>
    </Stack>
  );
};

export default DashboardOverview;
